import React from 'react';
import { ESTADO_RUN } from './procesosUtils';

export const EstadoRun = ({ estado, testid }) => {
  const e = ESTADO_RUN[estado] || ESTADO_RUN.omitida;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${e.cls}`} data-testid={testid}>
      <span className={`h-1.5 w-1.5 rounded-full ${e.dot} ${estado === 'en_ejecucion' ? 'animate-pulse' : ''}`} />
      {e.label}
    </span>
  );
};

export default EstadoRun;
